import * as axios from 'axios';
import { getAuthHeaders } from './request';

export const userDataRequest = async (method, path, params = {}, authHeaders = false, data = {}) => {
  let headers = {};
  if (authHeaders) {
    headers = getAuthHeaders();
  }
  if (params.headers != null) {
    headers = {
      ...headers,
      ...params.headers
    };
  }
  return axios({
    method,
    withCredentials: true,
    params: params.queryParams,
    data,
    /*
    #TODO: Find a different way to get this variable from
    outside the React model.
    -- TJC - May 07, 2021
    */
    // When adding the path, include a forward slash at the beginning
    url: `${window.__env.REACT_APP_USER_DATA_API_URL}${path}`,
    headers,
    timeout: 30000, // 30 second timeout
    maxRedirects: 5,
    validateStatus: function (status) {
      return status >= 200 && status < 300; // default
    }
  })
  .then((response) => {
    return { success: true, data: response.data.result };
  })
  .catch((error) => {
    return { success: false, data: error };
  });
};